import { observable, action, runInAction, makeObservable, IObservableArray } from 'mobx'
import { types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import fetch from '../../utils/fetch'

export const callMailer = (actionName, method, body, callback) => {
  return fetch(`/api/${actionName}`, {
    method: method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }).then(res => {
    callback()
    return res.json()
  })
}

class EmailerProvider {
  isLoading = false
  data = [] as IObservableArray
  config

  constructor (config = void 0) {
    makeObservable(this, {
      isLoading: observable,
      data: observable,
      query: action
    })

    this.config = config
  }

  sendEmail = async data => {
    try {
      const res = await fetch(`/api/datasource/${this.config.dbKey}/sendEmail`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })

      const emailHistory = await res.json()

      return emailHistory
    } catch (err) {
      console.log('ERROR WHEN SENDING EMAILS >> ', err)
    }
  }

  sendBulkEmail = async data => {
    try {
      const res = await fetch(`/api/datasource/${this.config.dbKey}/sendBulkEmail`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })

      const emailHistory = await res.json()

      return emailHistory
    } catch (err) {
      console.log('ERROR WHEN SENDING EMAILS >> ', err)
    }
  }

  query = async context => {
    try {
      runInAction(() => {
        this.isLoading = true
      })

      const res = await fetch(`/api/datasource/${this.config.dbKey}/getTemplates`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const templates = await res.json()

      runInAction(() => {
        this.data.replace(templates)
        this.isLoading = false
      })

      return templates
    } catch (err) {
      console.log('ERROR WHEN FETCHING TEMPLATES >> ', err)
    }
  }
}

const providerInstance = new EmailerProvider()

export default t
  .model('EmailerConfig', {
    type: t.optional(t.string, 'Emailer'),
    templateId: t.maybe(t.string)
  })
  .views(self => ({
    get providerInstance () {
      return providerInstance
    },
    get provider () {
      return EmailerProvider
    },
    labels () {
      const p = providerInstance
      const childNodes = Object.keys(p)
        .filter(k => typeof p[k] === 'function')
        .map(f => ({
          key: f,
          label: f,
          secondaryLabel: 'FUNCTION',
          meta: { fieldPath: f }
        }))

      return {
        key: (self as any).id,
        label: (self as any).name,
        childNodes: [
          {
            key: 'methods',
            label: 'Methods',
            childNodes
          },
          {
            key: 'data',
            label: 'Data'
          },
          {
            key: 'state',
            label: 'State',
            childNodes: [
              {
                key: 'isLoading',
                label: 'isLoading',
                secondaryLabel: 'state'
              }
            ]
          }
        ]
      }
    }
  }))
  .actions(crudActions)
